/* Kalma Volt — galería con flechas/deslizar y vista de ejemplo */
(function () {
  'use strict';
  /* Galería del producto: flechas, deslizar con el dedo y miniaturas.
     theme.js solo activa las miniaturas si hay formulario de compra; aquí se cubre el resto. */
  document.querySelectorAll('.kv-product .k-buy__gallery').forEach(function (gal) {
    var main = gal.querySelector('.k-buy__main');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.k-buy__thumb'));
    if (!main || thumbs.length < 2) return;
    var themeHandles = !!document.querySelector('form[data-buy-form]');
    var current = function () { var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); return i < 0 ? 0 : i; };
    var show = function (i) {
      i = (i + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var img = main.querySelector('img');
      if (!img) { img = document.createElement('img'); main.appendChild(img); }
      img.src = t.getAttribute('data-img');
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    if (!themeHandles) thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    main.style.position = 'relative';
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kv-gal__arrow kv-gal__arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Foto anterior' : 'Foto siguiente');
      b.textContent = dir === 'prev' ? '‹' : '›';
      b.addEventListener('click', function (e) { e.preventDefault(); show(current() + (dir === 'prev' ? -1 : 1)); });
      gal.appendChild(b);
    });
    var place = function () { gal.style.setProperty('--kv-gal-mid', (main.offsetTop + main.offsetHeight / 2) + 'px'); };
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    if (window.ResizeObserver) new ResizeObserver(place).observe(main);
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(current() + (dx < 0 ? 1 : -1));
    });
  });

  /* Vista de ejemplo (producto en borrador): packs, cantidad y aviso del botón */
  document.querySelectorAll('[data-kv-demo]').forEach(function (demo) {
    var priceBox = document.querySelector('[data-kv-demo-price]');
    var radios = demo.querySelectorAll('input[name="kv_demo_pack"]');
    var update = function () {
      radios.forEach(function (r) { r.closest('.kv-pack').classList.toggle('is-selected', r.checked); });
      var r = demo.querySelector('input[name="kv_demo_pack"]:checked');
      if (!r || !priceBox) return;
      var html = '<span class="k-price__now">' + r.getAttribute('data-now') + '</span>';
      if (r.getAttribute('data-was')) html += ' <span class="k-price__was">' + r.getAttribute('data-was') + '</span>';
      priceBox.innerHTML = html;
    };
    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
    var qty = demo.querySelector('.k-qty input');
    var minus = demo.querySelector('[data-kv-demo-minus]');
    var plus = demo.querySelector('[data-kv-demo-plus]');
    if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (qty && plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    var atc = demo.querySelector('[data-kv-demo-atc]');
    var note = demo.querySelector('[data-kv-demo-note]');
    if (atc && note) atc.addEventListener('click', function () { note.hidden = false; });
  });
})();

/* Cuenta atrás en cajas hasta una fecha fija (no se reinicia; al llegar a cero se oculta) */
(function () {
  document.querySelectorAll('[data-kv-cd]').forEach(function (el) {
    var end = parseInt(el.getAttribute('data-kv-cd'), 10) * 1000;
    if (!end) return;
    var box = function (u) { return el.querySelector('[data-u="' + u + '"]'); };
    var pad = function (n) { return String(n).padStart(2, '0'); };
    (function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; return; }
      var days = Math.floor(d / 86400000), h = Math.floor((d % 86400000) / 3600000), m = Math.floor((d % 3600000) / 60000), s = Math.floor((d % 60000) / 1000);
      box('d').hidden = days === 0;
      box('d').querySelector('b').textContent = pad(days);
      box('h').querySelector('b').textContent = pad(h);
      box('m').querySelector('b').textContent = pad(m);
      box('s').querySelector('b').textContent = pad(s);
      setTimeout(tick, 1000);
    })();
  });
})();
